<script lang="ts">
  import { DistributorEmployeeRole } from "@shared/types/Distributor";
  import Flash from "@shared/services/flashv2.js";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import PhoneInput from "@shared/svelte/Components/PhoneInput.svelte";
  import FormErrors from "@shared/svelte/Components/FormErrors.svelte";
  import { form, bindClass } from "svelte-forms";
  import { goto } from "@roxi/routify";

  import type { DistributorEmployee } from "@shared/types/Distributor";

  export let show: boolean;

  const closeModal = () => {
    show = false;
  };
  let employee: DistributorEmployee = {
    role: DistributorEmployeeRole.SalesRep,
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
  };
  let errors = { messages: [] };
  let isSaving = false;

  const roleOptions: { name: string; value: DistributorEmployeeRole }[] = [
    { name: "Sales Rep", value: DistributorEmployeeRole.SalesRep },
    { name: "Manager", value: DistributorEmployeeRole.Manager },
    { name: "Distributor Admin", value: DistributorEmployeeRole.DistributorAdmin },
    { name: "Payments Admin", value: DistributorEmployeeRole.PaymentsAdmin },
  ];

  const submit = () => {
    saveEmployee();
  };

  const employeeForm = form(() => {
    const formObj = {
      email: {
        value: employee.email,
        validators: ["required"],
      },
      firstName: {
        value: employee.firstName,
        validators: ["required"],
      },
      lastName: {
        value: employee.lastName,
        validators: ["required"],
      },
      phone: {
        value: employee.phone,
        validators: ["required"],
      },
      role: {
        value: employee.role,
        validators: ["required"],
      },
    };
    return formObj;
  });

  const saveEmployee = () => {
    isSaving = true;
    if (!$employeeForm.valid) {
      errors.messages = ["Please fill out all required fields."];
      isSaving = false;
      return;
    }
    HttpPromise({
      method: "POST",
      url: "/api/distributor/user/",
      data: {
        user: {
          email: employee.email.trim(),
          first_name: employee.firstName.trim(),
          last_name: employee.lastName.trim(),
          phone: employee.phone,
          role: employee.role,
        },
      },
    }).then(
      function success(res) {
        isSaving = false;
        Flash.now({
          type: "success",
          message: `Successfully Created New Employee`,
        });

        closeModal();
        $goto("/distributor/sales_reps/:salesRepId", { salesRepId: res.sales_rep_info.id });
      },
      function error(res) {
        isSaving = false;
        errors.messages = [res];
      },
    );
  };
</script>

<Modal fizzModal={true} size="medium" bind:show overflowY="scroll">
  <div class="fizz-inset-square-32 fizz-surface" data-testid="new-employee-modal">
    <div class="fizz-heading-4 fizz-flex-row fizz-space-between">
      <div> New Employee </div>
      <div
        id="close-employee-modal"
        class="cursor-pointer fizz-align-right"
        on:click={() => closeModal()}
      >
        &times;
      </div>
    </div>
    <FormErrors {errors} />

    <div class="fizz-inset-vertical-16 fizz-flow-16">
      <label class="fizz-label fizz-stack-4" for="employee-email">Email</label>
      <input
        type="email"
        class="fizz-input-text fizz-full-width"
        bind:value={employee.email}
        use:bindClass={{ form: employeeForm }}
        required
        id="employee-email"
      />

      <label class="fizz-label fizz-stack-4" for="employee-first-name">First Name</label>
      <input
        type="text"
        class="fizz-input-text fizz-full-width"
        bind:value={employee.firstName}
        use:bindClass={{ form: employeeForm }}
        required
        id="employee-first-name"
      />

      <label class="fizz-label fizz-stack-4" for="employee-last-name">Last Name</label>
      <input
        type="text"
        class="fizz-input-text fizz-full-width"
        bind:value={employee.lastName}
        use:bindClass={{ form: employeeForm }}
        required
        id="employee-last-name"
      />

      <PhoneInput
        bind:value={employee.phone}
        label={"Phone"}
        id="phone"
        required
        extraClasses={"fizz-input-text"}
      />

      <label class="fizz-label fizz-stack-4" for="employee-role">Role</label>
      <select class="fizz-select fizz-full-width" id="employee-role" bind:value={employee.role}>
        {#each roleOptions as option, index}
          <option value={option.value} selected={index === 0}>{option.name}</option>
        {/each}
      </select>
    </div>

    <div class="fizz-inset-vertical-16 fizz-flex-row fizz-space-between">
      <button class="fizz-button" on:click={() => closeModal()}>Cancel</button>
      <div class={isSaving ? "fizz-icon-spinner-small" : ""}></div>
      <button class="fizz-button-primary" id="create-employee" on:click={submit}> Save </button>
    </div>
  </div>
</Modal>
